const clean = (value) => (value ? value.trim() : '');
const mfaDemo = process.env.NODE_ENV !== 'production' &&
  clean(process.env.REACT_APP_MFA_DEMO).toLowerCase() === 'true';

const config = {
  apiUrl: mfaDemo ? 'http://127.0.0.1:8000' : clean(process.env.REACT_APP_API_URL) || 'http://localhost:8000',
  companyProfileUrl: clean(process.env.REACT_APP_COMPANY_PROFILE_URL) || 'https://www.opensesame-tech.com/about/ost',
  companyProfileEnglishUrl: clean(process.env.REACT_APP_COMPANY_PROFILE_EN_URL) || 'https://www.opensesame-tech.com/en/about/ost/',
  companyHomepageUrl: clean(process.env.REACT_APP_COMPANY_HOMEPAGE_URL) || 'https://www.opensesame-tech.com/',
  companyHomepageEnglishUrl: clean(process.env.REACT_APP_COMPANY_HOMEPAGE_EN_URL) || 'https://www.opensesame-tech.com/en/',
  companyEmailDomain: clean(process.env.REACT_APP_COMPANY_EMAIL_DOMAIN).toLowerCase().replace(/^@/, ''),
  appVersion: clean(process.env.REACT_APP_VERSION) || 'dev',
  mfaDemo,
  passwordRotationTestMinutes: (() => {
    const raw = clean(process.env.REACT_APP_PASSWORD_ROTATION_TEST_MINUTES) || '0';
    const value = Number(raw);
    return Number.isFinite(value) && value >= 0 ? value : 0;
  })(),
  cognito: {
    userPoolId: clean(process.env.REACT_APP_COGNITO_USER_POOL_ID),
    clientId: clean(process.env.REACT_APP_COGNITO_CLIENT_ID),
    region: clean(process.env.REACT_APP_COGNITO_REGION) || 'ap-northeast-1',
  },
};

export default config;
